<template>
  <div class="menu-dialog" :class="[position]">
    <ul>
      <li
        v-if="canDelete"
        @click="emit('delete')"
        :class="{ disabled }"
        data-qa="shift-control-menu-item-cancel"
      >
        <vita-icon name="cross-red" />
        <span>Отменить</span>
      </li>
      <li
        v-if="canUpdate"
        @click="emit('update')"
        :class="{ disabled }"
        data-qa="shift-control-menu-item-edit"
      >
        <vita-icon name="pencil" />
        <span>Редактировать</span>
      </li>
      <li v-if="canCopy" @click="emit('copy')" data-qa="shift-control-menu-item-copy">
        <vita-icon name="copy" />
        <span>Копировать</span>
      </li>
      <li
        v-if="canInfo"
        @click="emit('info')"
        :class="{ disabled }"
        data-qa="shift-control-menu-item-info"
      >
        <vita-icon name="pencil-edit" />
        <span>Информация о смене</span>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import VitaIcon from '@/components/UI/VitaIcon.vue'

interface Props {
  // Положение меню относительно смены, приходит из VitaShiftControl
  position: string
  canDelete: boolean
  canUpdate: boolean
  canCopy: boolean
  canInfo: boolean
  // Идёт запрос, действия недоступны
  disabled: boolean
}

defineProps<Props>()

const emit = defineEmits(['delete', 'update', 'copy', 'info'])
</script>

<style scoped lang="scss">
.menu-dialog {
  position: absolute;
  z-index: 999;
  top: 23px;
  right: -8px;
  min-width: 160px;
  padding: 4px;
  background: #ffffff;
  box-shadow: -1px 0px 12px rgba(0, 0, 0, 0.15);
  border-radius: 3px;

  &.m-right {
    left: unset;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }

  li {
    padding: 6px 8px;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    user-select: none;

    &.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    svg {
      min-width: max-content;
    }

    span {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 15px;
      color: #333333;
    }

    &:hover {
      background: #f9f9f9;
    }
  }
}
</style>
